/**
 * This is the rich dropdown component on the vestigings landingspagina
 * and the codelab front search dropdown
 * The examentraining rich dropdown uses initially also this component
 * until the ajax call completes and it gets replaced by the react component
 *
 * Warning: Be aware that there can be multiple richDropdown components on one page
 */
export class RichDropdown {
  constructor() {
    this.$dropdown = $('.rich-dropdown');
    if (this.$dropdown.length === 0) {
      return;
    }

    this.$container = this.$dropdown.find('.rich-dropdown__container');
    this.$checkboxes = $('.rich-dropdown input[type="checkbox"]');
    this.$placeholder = $('.rich-dropdown__placeholder');
    const $closeTrigger = $('body:not(".rich-dropdown"), .rich-dropdown__container');
    const $preselected = this.$dropdown.find('input[type="checkbox"]:checked');

    // Show initially selected subjects into the rich dropdown placeholder div
    if ($preselected.length > 0) {
      this._showSelected();
    }

    // bind events
    this.$container.on('click', e => e.stopPropagation());
    this.$placeholder.on('click',(e) => this._openDropdown(e));
    this.$checkboxes.on('change', (e) => this._showSelected(e));
    $closeTrigger.on('click', () => this._closeDropdown());
  }

  /**
     * Open the dropdown in case it is not disabled
     * e.stopPropagation is used so the _closeDropdown() is not immediately triggered
     * @param e
     * @private
     */
  _openDropdown(e) {
    e.stopPropagation();
    let $dropdown = $(e.currentTarget).closest('.rich-dropdown');

    if (!$dropdown.hasClass('rich-dropdown--disabled')){
      $dropdown.toggleClass('open');
    }
  }

  /**
     * Close the dropdown
     * @private
     */
  _closeDropdown() {
    if (this.$dropdown.hasClass('open')){
      this.$dropdown.removeClass('open');
    }
  }

  /**
     * Prints the initial selected subjects into the placeholder div
     */
  _showSelected() {
    let selected = '';
    let $preselected = this.$dropdown.find('input[type="checkbox"]:checked');
    let placeholder = '';

    $preselected.each((index, checkbox) => {
      selected += (checkbox.value + ', ');
    });

    if (selected.length > 0) {
      // remove the trailing comma
      placeholder = selected.substring(0, selected.length - 2);
    } else {
      // restore initial placeholder
      placeholder = this.$placeholder.data('placeholder');
    }
    this.$placeholder.html(placeholder);
  }
}
